import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles,  MenuItem, Menu, ListItemIcon, Checkbox, Divider, } from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { HolidayStyle } from './Holiday.style';
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import * as UserActions from '@services/user/user.actions';

import { ICalendarSetting } from '@app-types/websocket/user.types';
import { CountryType,unknonwHolidaysCountry } from './holidayTypes';
const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  open:boolean;
}

interface IProps extends WithStyles<typeof HolidayStyle> {
  userId:number;
  disabled:boolean;
  selectedCountry:CountryType;
  close: () => void;
  updateCalendarSettings: (data: ICalendarSetting) => void;
  setCountry: (country: CountryType) => void;
}

class HolidaysSettings extends React.Component<IProps, IState> {

  private countryOptionsRef: React.RefObject<HTMLDivElement> = React.createRef();

  constructor(props: IProps) {
    super(props);

    this.state = {
      open:false,
    };
  }

  public render() {
    const {classes, userId, disabled, selectedCountry} = this.props;
    const {open} = this.state;


    return (<>
      {/** This is the entry in the list */}
      <MenuItem
        disabled={disabled}
        className={this.props.classes.menuListItem}
        onClick={() => this.setState({open:!this.state.open})}>
        <div className={this.props.classes.menuItemTitle}>
          {tn.lang.calenderPublicHolidays}
        </div>
        <div className={this.props.classes.menuItemEnd} ref={this.countryOptionsRef}>
          <ArrowRightIcon />
        </div>
      </MenuItem>

      {/** This is the submenu */}
      <Menu 
        anchorEl={this.countryOptionsRef.current}
        getContentAnchorEl={null}
        open={open && !disabled}
        anchorReference="anchorEl"
        onClose={() => {this.setState({open:false});}}
        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        transformOrigin={{vertical: 'top', horizontal: 'center'}}
        classes={{
          paper: classes.menuPaper,
          list: classes.menuList,
        }}
      >
          {this.generateCountryOption(tn.lang.sweden, "SE")}
          {this.generateCountryOption(tn.lang.finland, "FI")}
          {this.generateCountryOption(tn.lang.norway,"NO")}
          {this.generateCountryOption(tn.lang.denmark,"DK")}
          {this.generateCountryOption(tn.lang.spain,"ES")}
          {this.generateCountryOption(tn.lang.switzerland,"CH")}
          {this.generateCountryOption(tn.lang.france,"FR")}
          {this.generateCountryOption(tn.lang.germany,"DE")}
          {this.generateCountryOption(tn.lang.belgium,"BE")}
          {this.generateCountryOption(tn.lang.nl,"NL")}
          {this.generateCountryOption(tn.lang.uk,"GB")}
          {this.generateCountryOption(tn.lang.us,"US")}
          {this.generateCountryOption(tn.lang.ca,"CA")}
        <Divider/>
        <MenuItem
          key={"close"}
          className={this.props.classes.menuListItem}
          onClick={() => this.setState({open:false})}>  
          <div className={this.props.classes.menuItemTitle}>
            {tn.lang.close}
          </div>
        </MenuItem>
      </Menu>
      
    </>);
  }

  private generateCountryOption(country:string, countryCode: CountryType) {
    return (<MenuItem
        key={countryCode} 
        className={this.props.classes.menuListItem}
        onClick={() => {
          this.props.setCountry(countryCode);
          this.setState({open:false});
          this.props.close();
        }}>
        <ListItemIcon>
          <Checkbox 
          color="primary" 
          id="showweek" 
          checked={this.props.selectedCountry === countryCode} 
          readOnly={true} 
          edge="start"/>
        </ListItemIcon>   
        <div className={this.props.classes.menuItemTitle}>
          {country}
        </div>
      </MenuItem>);
  }
}



function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  const selectedCountry: CountryType = (state.user.calendarSettings && state.user.calendarSettings.holidaysCountry)
    ? state.user.calendarSettings.holidaysCountry 
    : unknonwHolidaysCountry.Unknown;

  return {
    userId,
    selectedCountry,
  };
}


const mapDispatchToProps = {
  updateCalendarSettings: UserActions.updateCalendarSettings,
  setCountry: UserActions.saveHolidayRegion,
};


export default connect(mapStateToProps,mapDispatchToProps)(withStyles(HolidayStyle)(HolidaysSettings));



// WEBPACK FOOTER //
// ./src/components/calendar2/holidays/HolidaysSettings.tsx